import React, {memo} from 'react';
import {cmpByKey} from '../../modules/helpers';


export default memo(
	/**
	 * @param {{
	 *   image: import('../types').Image,
	 *   widthPercent?: number,
	 *   className?: string,
	 * }} props
	 */
	function Image({ image, widthPercent = 100, className }) {
		const images = [...image.resized, image].sort(cmpByKey((img) => img.width));

		const srcSet = images
			.map((img) => `${img.url} ${img.width}w`)
			.join(", ");

		const sizes = images
			.map((img, i) => {
				if (images.length - 1 === i) {
					return `${img.width}px`;
				} else {
					return `(max-width: ${img.width / widthPercent * 100}px) ${img.width}px`;
				}
			})
			.join(", ");

		return (
			<img
				className={className}
				srcSet={srcSet}
				sizes={sizes}
				src={image.url}
				alt={image.alt}
			/>
		);
	}
);
